import React from 'react';
import {ErrorBoundary} from 'react-error-boundary';

function WithErrorBoundary(Component) {
  return React.memo((props) => {
    return (
      <ErrorBoundary
        FallbackComponent={({error, resetErrorBoundary}) => (
          <div className="awl-container justify-content-center align-items-center">
            <h4>An Error Occured while performing the last action.</h4>
            <br />
            <button
              // onClick={() => window.location.reload()}
              onClick={resetErrorBoundary}
              className="btn btn-secondary"
            >
              Try again
            </button>
          </div>
        )}
        onError={(error, info) => {
          //todo: setstate and use the state in sidemenu to refresh the page to that url, instead of navigating with react-router
          //call api
          /*eslint-disable-next-line no-console*/
          console.log('error boundary', error, info);
        }}
        onReset={() => {
          /*eslint-disable-next-line no-console*/
          console.log('reset triggered');
        }}
      >
        <Component {...props} />
      </ErrorBoundary>
    );
  });
}

export default WithErrorBoundary;
